import React, { FC } from 'react'
import { UITypes } from 'LibNeo'
import { BadgeContainer } from './styled'

interface BadgeProps {
	count: number | JSX.Element
	type?: UITypes
	className?: string
	children?: string | JSX.Element
	title?: string
	offset?: [number | string, number | string]
}

export const BadgeComponent: FC<BadgeProps> = ({
	type = UITypes.PRIMARY,
	className,
	count,
	children,
	title,
	offset,
}) => {
	return (
		<BadgeContainer title={title} type={type} className={className} count={count} offset={offset}>
			{children}
		</BadgeContainer>
	)
}
